import { setSecondaryNavOptions } from './secondary-nav.actions';
import { updateSecondaryNavOptions } from './secondary-nav.repository';
import {
  createEffect,
  ofType,
  registerEffects,
  removeEffects,
} from '@ngneat/effects';
import { tap } from 'rxjs/operators';

const setSecondaryNavOptions$ = createEffect((actions) =>
  actions.pipe(
    ofType(setSecondaryNavOptions),
    tap(({ key, options }) => {
      updateSecondaryNavOptions(key, options);
    })
  )
);

const effects = [setSecondaryNavOptions$];

export function registerSecondaryNavEffects() {
  registerEffects(effects);
}

export function deregisterSecondaryNavEffects() {
  removeEffects(effects);
}
